export default "__VITE_ASSET__nCMj77kb__"